import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const UserLoginCard = () => {
  return (
    <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border-2 border-transparent hover:border-emerald-500">
      {/* Card header with gradient */}
      <div className="bg-gradient-to-br from-emerald-500 to-emerald-600 p-6 text-white">
        <div className="flex items-center justify-between mb-4">
          <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
            <Icon name="User" size={32} color="#FFFFFF" />
          </div>
          <div className="bg-emerald-400/30 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-medium">
            Usuario
          </div>
        </div>
        <h2 className="text-2xl font-bold mb-2">Iniciar Sesión como Usuario</h2>
        <p className="text-emerald-100">
          Accede a descuentos exclusivos y beneficios en negocios afiliados
        </p>
      </div>

      {/* Card body */}
      <div className="p-6">
        <div className="space-y-4 mb-6">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-emerald-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Descuentos Exclusivos</h3>
              <p className="text-sm text-gray-600">
                Obtén descuentos en cientos de empresas afiliadas
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-emerald-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Escaneo QR Rápido</h3>
              <p className="text-sm text-gray-600">
                Accede a promociones escaneando códigos QR en negocios
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-emerald-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Programa de Recompensas</h3>
              <p className="text-sm text-gray-600">
                Gana puntos y beneficios con el programa Bizznet Rewards
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-emerald-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Notificaciones en Tiempo Real</h3>
              <p className="text-sm text-gray-600">
                Recibe alertas de nuevas promociones y ofertas especiales
              </p>
            </div>
          </div>
        </div>

        {/* Login button */}
        <Link
          to="/user-login"
          className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold rounded-xl transition-colors duration-200 shadow-md hover:shadow-lg group-hover:scale-105 transform"
        >
          <Icon name="LogIn" size={20} />
          <span>Iniciar Sesión como Usuario</span>
          <Icon name="ArrowRight" size={20} />
        </Link>

        {/* Additional info */}
        <div className="mt-4 text-center">
          <p className="text-xs text-gray-500">
            Al iniciar sesión, aceptas nuestros{' '}
            <Link to="/terms-and-conditions" className="text-emerald-600 hover:underline">
              Términos y Condiciones
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserLoginCard;